import { CSSProperties } from 'react';
import { CaptionStyleId } from '../types';

const styles: { [key: string]: CSSProperties } = {
  horimozi1: {
    fontSize: '0.875rem',
    fontWeight: 900,
    lineHeight: 1.2,
    color: '#fff',
    textTransform: 'uppercase',
    textShadow:
      '0 0 20px #000, 0 0 21px #000, 0 0 22px #000, 0 0 23px #000, 0 0 24px #000, 0 0 25px #000, 0 0 26px #000, 0 0 27px #000, 0 0 28px #000, 0 0 29px #000',
    backgroundColor: 'rgba(75, 85, 99, 1)',
  },
  tracy: {
    fontSize: '0.875rem',
    fontWeight: 900,
    lineHeight: 1.2,
    color: '#fff',
    textTransform: 'uppercase',
    textShadow: '0 0 8px #fff',
  },
  ali: {
    fontSize: '0.875rem',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 900,
    color: '#020202',
    background: '#E7E5E7',
    padding: '2.5px 6px',
    borderRadius: '20%',
  },
  beast: {
    fontFamily: '"Bangers", sans-serif',
    color: '#fff',
    lineHeight: '1.2',
    textTransform: 'uppercase',
    textShadow: '-2px -2px 0 #000, 2px -2px 0 #000, -2px 2px 0 #000, 2px 2px 0 #000',
  },
};

export const CAPTION_STYLES = [
  {
    id: CaptionStyleId.Horimozi1,
    component: <div style={styles.horimozi1}>Hormozi 1</div>,
  },
  {
    id: CaptionStyleId.Tracy,
    component: <div style={styles.tracy}>Tracy</div>,
  },
  {
    id: CaptionStyleId.Ali,
    component: <div style={styles.ali}>Ali</div>,
  },
  {
    id: CaptionStyleId.Beast,
    component: <div style={styles.beast}>Beast</div>,
  },
];
